import { render, staticRenderFns } from "./grid-col-span-editor.vue?vue&type=template&id=3386d48e&scoped=true"
import script from "./grid-col-span-editor.vue?vue&type=script&lang=js"
export * from "./grid-col-span-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386d48e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3386d48e')) {
      api.createRecord('3386d48e', component.options)
    } else {
      api.reload('3386d48e', component.options)
    }
    module.hot.accept("./grid-col-span-editor.vue?vue&type=template&id=3386d48e&scoped=true", function () {
      api.rerender('3386d48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-grid-col/grid-col-span-editor.vue"
export default component.exports